import { WechatContact } from "../../types";
import EventBus from "../event-bus";
const getContactDetailHook = new EventBus<WechatContact>(
  "getContactDetailHook"
);

export default getContactDetailHook;
